/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const imageDataRequestCategorySchema = z.enum(['image', 'file'])

export type ImageDataRequestCategorySchema = z.infer<typeof imageDataRequestCategorySchema>
